module.exports = __webpack_public_path__ + "img/Proliferation-MELA_GSE185386.e827925f.png";